import React, { useEffect, useMemo, useRef, useState } from "react"
import TableContainer from "components/Common/TableContainer"
import moment from "moment"
import arrowDown from "../../../assets/images/icons/arrow-down.svg"
import eye from "../../../assets/images/icons/eye.svg"
import resend from "../../../assets/images/icons/resend.svg"
import copy from "../../../assets/images/icons/copy.svg"
import { Link } from "react-router-dom"
import { useDeleteWealthPartnersMutation } from "store/api/wealth-partner/wealth-partners.api"
import DeleteConfirmationModal from "modals/deleteConfirmation"
import ReinviteConfirmationModal from "modals/reinviteConfirmation"
import { UncontrolledTooltip } from "reactstrap"
import AddReferalModal from "modals/addReferalModal"
import { getInvestorsStatus } from "helpers/common"
import {
  useLazyGetReferralsQuery,
  useReInviteReferalMutation,
} from "store/api/wealthpartnerapi/referrals/referrals.api"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"
import toast from "react-hot-toast"
import { copyToClipboard } from "helpers/utils"
// import check from "../../../assets/images/icons/right-check.svg"
// import crossIcon from "../../../assets/images/icons/close-icon-red.svg"

const defaultFilters = {
  search: "",
  page: 1,
  pageSize: 20,
  timestamp: "",
}

const InvestorManagementTable = () => {
  const [getResults, { isFetching }] = useLazyGetReferralsQuery()
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [onDelete, { isLoading: isDeleting }] =
    useDeleteWealthPartnersMutation()
  const [onReinvite, { isLoading: isInviting }] = useReInviteReferalMutation()
  const [isToast, setIsToast] = useState(false)
  const [isReinviteToast, setIsReinviteToast] = useState(false)
  const deleteRef = useRef()
  const reinviteRef = useRef()
  const [openReferal, setOpenReferal] = useState(false)
  //meta title
  document.title = "Investor Management"

  useEffect(() => {
    getList()
  }, [filters])

  const getList = async () => {
    try {
      const { data } = await getResults(filters).unwrap()
      setData(data?.rows)
      setCount(data?.count)
    } catch (e) {}
  }

  const onActionSuccess = () => {
    setIsToast(false)
    deleteRef.current = null
    setFilters((prev) => ({ ...prev, page: 1, timestamp: moment().unix() }))
  }

  const onRefresh = () => {
    setOpenReferal(false)
    setFilters({ ...defaultFilters, timestamp: moment().unix() })
  }

  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            avatar_url={row?.original?.avatar_url}
            email={row?.original?.email}
            name={row?.original?.name}
          />
        ),
      },
      {
        header: "Code",
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: () => (
          <div className="flex items-center gap-2">
            Entity Type <img src={arrowDown} height={"15px"} alt="" />
          </div>
        ),
        accessorKey: "entity_type",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Pan",
        accessorKey: "pan_no",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => <>{row?.original.pan_no || "-"}</>,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <div className="code-status">
            {getInvestorsStatus(row?.original.status, row?.original.deleted_at)}
          </div>
        ),
      },
      {
        id: "delete",
        header: "Actions",
        cell: ({ row }) => {
          const resendTooltip = `resendTooltip-${row?.original.id}`
          const viewTooltip = `editTooltip-${row?.original.id}`
          const copyTooltip = `copyTooltip-${row?.original.id}`
          if (row?.original?.status === "INVITE_REJECT") return null

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              {(row?.original.status === "LINK_SENT" ||
                row?.original.status === "LINK_EXPIRED") && (
                <div
                  className="action-delete"
                  onClick={() => {
                    reinviteRef.current = row?.original
                    setIsReinviteToast(true)
                  }}
                  id={resendTooltip}
                >
                  <img src={resend} alt="" />
                  <UncontrolledTooltip placement="top" target={resendTooltip}>
                    Resend Link
                  </UncontrolledTooltip>
                </div>
              )}
              {row.original.status === "INVITE_PENDING" ? (
                <></>
              ) : (
                <>
                  <div className="action-view">
                    <Link
                      to={
                        row?.original.status === "LINK_SENT" ||
                        row?.original.status === "LINK_EXPIRED"
                          ? `/investor-management/invite/${row?.original.id}`
                          : `/investor-management/view/${row?.original.id}`
                      }
                      id={viewTooltip}
                    >
                      <img src={eye} alt="" />
                      <UncontrolledTooltip placement="top" target={viewTooltip}>
                        View
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                  {row?.original?.token &&
                    row?.original.status === "LINK_SENT" && (
                      <div
                        className="action-delete"
                        onClick={() => {
                          const url = `${process.env.REACT_APP_PUBLIC_URL}/verify-account/${row.original.token}`
                          if (url) {
                            copyToClipboard(url).then(() =>
                              toast.success("Link Copied")
                            )
                          }
                        }}
                        id={copyTooltip}
                      >
                        <img src={copy} alt="" />
                        <UncontrolledTooltip
                          placement="top"
                          target={copyTooltip}
                        >
                          Copy Link
                        </UncontrolledTooltip>
                      </div>
                    )}
                </>
              )}
            </div>
          )
        },
      },
    ],
    []
  )

  const FilterComponents = () => (
    <>
      <Link
        className="btn btn-secondary"
        to={"#"}
        onClick={() => setOpenReferal(true)}
      >
        <i className="mdi mdi-plus me-1"></i> Invite Investor
      </Link>
    </>
  )

  return (
    <>
      <TableContainer
        isLoading={isFetching}
        count={count}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        data={data}
        isGlobalFilter={true}
        isCustomPageSize={true}
        FilterComponents={FilterComponents}
        // isGlobalFilter={true}
        buttonName={"Add New Referral"}
        isPagination={true}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />

      {openReferal && (
        <AddReferalModal
          open={openReferal}
          setOpen={setOpenReferal}
          refresh={onRefresh}
        />
      )}

      {isToast && deleteRef && (
        <DeleteConfirmationModal
          open={isToast}
          id={deleteRef?.current?.id}
          setOpen={setIsToast}
          isLoading={isDeleting}
          onClose={() => {
            setIsToast(false)
            deleteRef.current = null
          }}
          title={"Delete Wealth Partner"}
          description="Are you sure you want to delete this wealth partner?"
          onDelete={onDelete}
          onSuccess={onActionSuccess}
        />
      )}

      {isReinviteToast && reinviteRef && (
        <ReinviteConfirmationModal
          open={isReinviteToast}
          id={reinviteRef?.current?.id}
          setOpen={setIsReinviteToast}
          isLoading={isInviting}
          onClose={() => {
            setIsReinviteToast(false)
            reinviteRef.current = null
          }}
          title="Resend Email"
          description="Are you sure you want to send verification email again?"
          onSend={onReinvite}
          onSuccess={() => {
            setIsReinviteToast(false)
            reinviteRef.current = null
            setFilters((prev) => ({
              ...prev,
              page: 1,
              timestamp: moment().unix(),
            }))
          }}
        />
      )}
    </>
  )
}

export default InvestorManagementTable
